import {PropsWithChildren} from "react"

type ConditionalWrapperProps = PropsWithChildren<{
  condition: boolean;
  renderWrapper: any;
}>;

export function SVVConditionalWrapper({
                                        condition,
                                        renderWrapper,
                                        children,
                                      }: ConditionalWrapperProps) {
  return condition ? renderWrapper(children) : children
}

SVVConditionalWrapper.displayName = "SVVConditionalWrapper";
